module.exports = __webpack_public_path__ + "static/img/function4.7ff4621.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/function4.gif
// module id = aXj6
// module chunks = 0